import { Box, Heading, Stack, Text, Tiles } from 'braid-design-system';

import * as styles from './StepByStepInfo.css';

export const StepByStepInfo = () => (
  <Stack space="large">
    <Heading level="2" align="center">
      Find the right buyer in 3 steps
    </Heading>

    <Tiles columns={{ mobile: 1, tablet: 3 }} space="medium">
      <Box
        background="brandAccentSoftActive"
        borderRadius="large"
        padding="large"
        height="full"
        data={{ testid: 'packages-step-card' }}
      >
        <Stack space="small" align="center">
          <Box
            background="brandAccent"
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            className={styles.stepNumber}
          >
            <Box component="span" className={styles.stepNumberText}>
              1
            </Box>
          </Box>

          <Text weight="strong" align="center" component="h3">
            Choose your advertising package
          </Text>

          <Text size="small" align="center">
            Select the advertising package that’s right for you.
          </Text>
        </Stack>
      </Box>

      <Box
        background="brandAccentSoftActive"
        borderRadius="large"
        padding="large"
        height="full"
        data={{ testid: 'packages-step-card' }}
      >
        <Stack space="small" align="center">
          <Box
            background="brandAccent"
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            className={styles.stepNumber}
          >
            <Box component="span" className={styles.stepNumberText}>
              2
            </Box>
          </Box>

          <Text weight="strong" align="center" component="h3">
            Create your business listing
          </Text>

          <Text size="small" align="center">
            You can keep the important parts confidential.
          </Text>
        </Stack>
      </Box>

      <Box
        background="brandAccentSoftActive"
        borderRadius="large"
        padding="large"
        height="full"
        data={{ testid: 'packages-step-card' }}
      >
        <Stack space="small" align="center">
          <Box
            background="brandAccent"
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            className={styles.stepNumber}
          >
            <Box component="span" className={styles.stepNumberText}>
              3
            </Box>
          </Box>

          <Text weight="strong" align="center" component="h3">
            Respond to buyers directly
          </Text>

          <Text size="small" align="center">
            We’ll notify you by email any time a buyer enquires about your
            business.
          </Text>
        </Stack>
      </Box>
    </Tiles>
  </Stack>
);
